(() => {
  const hero = document.querySelector("#hero.zl-hero");
  if (!hero) return;

  const video = hero.querySelector(".zl-hero__video");
  if (!video) return;

  console.log("[hero] watchdog activo");

  let lastTime = 0;
  let stalledCount = 0;
  let recovering = false;

  const setFallback = (reason) => {
    if (!hero.classList.contains("is-video-fallback")) {
      hero.classList.add("is-video-fallback");
      console.warn("[hero] fallback:", reason);
    }
  };

  const clearFallback = () => {
    if (hero.classList.contains("is-video-fallback")) {
      hero.classList.remove("is-video-fallback");
      console.log("[hero] fallback OFF (video ok)");
    }
  };

  // Recuperación: recarga el video sin recargar la página
  const recover = async (reason) => {
    if (recovering) return;
    recovering = true;

    console.warn("[hero] recover start:", reason);

    try {
      // pausa
      video.pause();

      // fuerza recarga del recurso (sin perder sources)
      video.load();

      // intenta play
      const p = video.play();
      if (p && typeof p.then === "function") await p;

      // si llegó aquí, está vivo
      stalledCount = 0;
      clearFallback();
      console.log("[hero] recover ok");
    } catch (e) {
      // si falla, nos quedamos con poster (no negro)
      setFallback("recover failed");
      console.error("[hero] recover failed:", e);
    } finally {
      recovering = false;
    }
  };

  // Eventos típicos de “me quedé sin video”
  video.addEventListener("stalled", () => recover("stalled event"));
  video.addEventListener("error",   () => recover("error event"));
  video.addEventListener("abort",   () => recover("abort event"));
  video.addEventListener("waiting", () => {
    stalledCount++;
    console.log("[hero] waiting...", stalledCount);
    if (stalledCount >= 3) recover("waiting x3");
  });

  // Watchdog: si el video deja de avanzar por X segundos → recover
  setInterval(() => {
    // si no está reproduciendo, no molestamos
    if (video.paused || video.ended) return;

    const t = video.currentTime;

    // si no avanzó nada desde la última revisión
    if (t === lastTime) {
      console.warn("[hero] video no avanza, intentando recover...");
      recover("currentTime frozen");
      // mientras tanto, dejamos el fondo visible
      setFallback("video frozen");
    } else {
      lastTime = t;
      clearFallback(); // video volvió a pintar frames
    }
  }, 4000);

  // Cuando vuelves a la pestaña, reintenta (a veces el navegador “duerme” el video)
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "visible") {
      recover("tab visible again");
    }
  });
})();


(() => {
  const toggle = document.querySelector(".nav-toggle");
  const drawer = document.getElementById("mobile-menu");
  const overlay = document.querySelector("[data-mobile-overlay]");
  const closeBtn = document.querySelector(".mobile-close");

  if (!toggle || !drawer || !overlay || !closeBtn) return;

  const openMenu = () => {
    document.body.classList.add("menu-open");
    toggle.setAttribute("aria-expanded", "true");
    drawer.setAttribute("aria-hidden", "false");
  };

  const closeMenu = () => {
    document.body.classList.remove("menu-open");
    toggle.setAttribute("aria-expanded", "false");
    drawer.setAttribute("aria-hidden", "true");
  };

  toggle.addEventListener("click", openMenu);
  closeBtn.addEventListener("click", closeMenu);
  overlay.addEventListener("click", closeMenu);

  // Cerrar con ESC
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && document.body.classList.contains("menu-open")) {
      closeMenu();
    }
  });

  // Cerrar al dar click en links internos y hacer scroll suave
  drawer.querySelectorAll("a").forEach(a => {
    a.addEventListener("click", (e) => {
      const href = a.getAttribute("href");
      if (!href) return;

      const url = new URL(href, window.location.origin);
      const esMismaPagina =
        url.pathname.replace(/\/+$/, "") === window.location.pathname.replace(/\/+$/, "");
      const tieneHash = !!url.hash;

      // Si es ancla de la misma página
      if (tieneHash && esMismaPagina) {
        e.preventDefault();

        const target = document.querySelector(url.hash);
        closeMenu();

        if (target) {
          setTimeout(() => {
            target.scrollIntoView({
              behavior: "smooth",
              block: "start"
            });
          }, 250);
        }
      } else {
        // Si es navegación normal, solo cierra el menú
        closeMenu();
      }
    });
  });
})();
// App entry (si no usas bundler, concatena en gulp o cambia a vanilla)
(() => {
  const header = document.getElementById('siteHeader');
  if (!header) return;

  const onScroll = () => {
    const y = window.scrollY || 0;
    header.classList.toggle('is-scrolled', y > 20);
    header.classList.toggle('is-transparent', y <= 20);
  };

  onScroll();
  window.addEventListener('scroll', onScroll, { passive: true });
})();

// Sliders
(() => {

  const slider = document.getElementById("solucionesSlider");
  if (!slider) return;

  const track = slider.querySelector(".soluciones-slider__track");
  const items = Array.from(slider.querySelectorAll(".soluciones-slider__item"));
  const cards = document.querySelectorAll(".product-card");

  if (items.length < 2) return;

  let index = 0;
  const delay = 3500;

  const activarCard = (cardId) => {

    cards.forEach(card => {
      card.classList.remove("activo");
    });

    const cardActiva = document.getElementById(cardId);
    if (cardActiva) {
      cardActiva.classList.add("activo");
    }

    console.log("Card activa:", cardId);
  };

  const goTo = (i) => {

    index = (i + items.length) % items.length;

    const x = items[index].offsetLeft;
    track.style.transform = `translateX(-${x}px)`;

    const cardRelacionada = items[index].dataset.card;
    activarCard(cardRelacionada);

    console.log("Slide actual:", index);
  };

  const next = () => goTo(index + 1);

  let timer = setInterval(next, delay);

  slider.addEventListener("mouseenter", () => clearInterval(timer));
  slider.addEventListener("mouseleave", () => timer = setInterval(next, delay));

  goTo(0);

  window.addEventListener("resize", () => goTo(index));

})(); 

(() => {
  const onReady = (fn) => {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", fn, { once: true });
    } else {
      fn();
    }
  };

  onReady(() => {
    console.log("[metodologia] init");

    const track = document.querySelector("#div_metodologia .div_row_metodologia");
    if (!track) return;

    const cards = Array.from(track.querySelectorAll(".div_row_cell_img"));
    if (!cards.length) return;

    const btnPrev = document.querySelector("#div_metodologia .div_metodologia_nav .prev");
    const btnNext = document.querySelector("#div_metodologia .div_metodologia_nav .next");

    const dotsWrap = document.querySelector("#div_metodologia .div_metodologia_dots");
    const dots = dotsWrap ? Array.from(dotsWrap.querySelectorAll("span")) : [];

    console.log("[metodologia] cards:", cards.length, "btnPrev:", !!btnPrev, "btnNext:", !!btnNext);

    let currentIndex = 0;

    const paintDots = (active) => {
      if (!dots.length) return;
      dots.forEach((d, i) => d.classList.toggle("dot_active", i === active));
    };

    const goToIndex = (i, reason) => {
      const total = cards.length;
      const idx = ((i % total) + total) % total; // loop real
      currentIndex = idx;

      console.log("[metodologia] goToIndex", idx, reason || "");

      cards[idx].scrollIntoView({
        behavior: "smooth",
        block: "nearest",
        inline: "center",
      });

      paintDots(idx);
    };

    // Detecta la tarjeta más visible (para actualizar currentIndex cuando el usuario arrastra)
    const getIndexByCenter = () => {
      const rTrack = track.getBoundingClientRect();
      const centerX = rTrack.left + rTrack.width / 2;

      let best = 0;
      let bestDist = Infinity;

      for (let i = 0; i < cards.length; i++) {
        const r = cards[i].getBoundingClientRect();
        const cCenter = r.left + r.width / 2;
        const dist = Math.abs(cCenter - centerX);
        if (dist < bestDist) {
          bestDist = dist;
          best = i;
        }
      }
      return best;
    };

    // Init
    currentIndex = getIndexByCenter();
    paintDots(currentIndex);

    // NEXT/PREV con loop garantizado
    if (btnNext) {
      btnNext.addEventListener("click", () => {
        console.log("[metodologia] NEXT click current:", currentIndex);
        goToIndex(currentIndex + 1, "next");
      });
    }

    if (btnPrev) {
      btnPrev.addEventListener("click", () => {
        console.log("[metodologia] PREV click current:", currentIndex);
        goToIndex(currentIndex - 1, "prev");
      });
    }

    // Scroll manual: mantener currentIndex sincronizado
    let t = null;
    track.addEventListener("scroll", () => {
      clearTimeout(t);
      t = setTimeout(() => {
        const idx = getIndexByCenter();
        if (idx !== currentIndex) {
          currentIndex = idx;
          console.log("[metodologia] scroll -> currentIndex:", currentIndex);
          paintDots(currentIndex);
        }
      }, 80);
    });

    // Test en consola
    window.__metodologiaGoTo = goToIndex;
    console.log("[metodologia] OK. Test: __metodologiaGoTo(0..6)");
  });
})();

document.addEventListener("DOMContentLoaded", () => {
  const item = document.querySelector(".nav-item--solutions");
  const trigger = document.querySelector(".nav-link--solutions");

  if (!item || !trigger) return;

  let pinned = false;

  trigger.addEventListener("click", (e) => {
    if (window.innerWidth <= 991) return;

    e.preventDefault();
    e.stopPropagation();

    if (pinned) {
      pinned = false;
      item.classList.remove("is-open");
      trigger.setAttribute("aria-expanded", "false");
    } else {
      pinned = true;
      item.classList.add("is-open");
      trigger.setAttribute("aria-expanded", "true");
    }
  });

  item.addEventListener("mouseenter", () => {
    if (window.innerWidth <= 991) return;

    item.classList.add("is-hover");
    if (!pinned) {
      trigger.setAttribute("aria-expanded", "true");
    }
  });

  item.addEventListener("mouseleave", () => {
    if (window.innerWidth <= 991) return;

    item.classList.remove("is-hover");
    if (!pinned) {
      trigger.setAttribute("aria-expanded", "false");
    }
  });

  document.addEventListener("click", (e) => {
    if (!item.contains(e.target)) {
      pinned = false;
      item.classList.remove("is-open");
      item.classList.remove("is-hover");
      trigger.setAttribute("aria-expanded", "false");
    }
  });

  window.addEventListener("resize", () => {
    if (window.innerWidth <= 991) {
      pinned = false;
      item.classList.remove("is-open");
      item.classList.remove("is-hover");
      trigger.setAttribute("aria-expanded", "false");
    }
  });


  const input = document.getElementById('buscadorMercer');
  const btn = document.getElementById('btnBuscadorMercer');
  const tags = document.querySelectorAll('.mmg-search__tag');

  const rutas = {
    "emt": "/producto/rTMS-YINGCHI-M-100",
    "neurofeedback": "/producto/mapeo-cerebral-qeeg-neurofeedback",
    "pacientes": "/pacientes",
    "tdah": "/tdah",
    "depresion": "/depresion",
    "depresión": "/depresion",
    "ansiedad": "/ansiedad",
    "toc": "/toc",
    "alta": "/alta",
    "baja": "/baja"
  };

  function normalizar(texto) {
    return texto
      .toLowerCase()
      .trim()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "");
  }

  function buscar() {
    const valor = normalizar(input.value);

    if (!valor) return;

    if (rutas[valor]) {
      window.location.href = rutas[valor];
      return;
    }

    for (const clave in rutas) {
      if (valor.includes(clave)) {
        window.location.href = rutas[clave];
        return;
      }
    }

    alert('No encontramos una coincidencia directa. Prueba con: EMT, Neurofeedback, Pacientes, TDAH, Depresión, Ansiedad o TOC.');
  }

  btn.addEventListener('click', buscar);

  input.addEventListener('keydown', function (e) {
    if (e.key === 'Enter') {
      e.preventDefault();
      buscar();
    }
  });

  tags.forEach(tag => {
    tag.addEventListener('click', function () {
      const url = this.getAttribute('data-url');
      if (url) window.location.href = url;
    });
  });
});

// Buscador
document.addEventListener('DOMContentLoaded', function () {
  const input = document.getElementById('buscadorMercer');
  const btn = document.getElementById('btnBuscadorMercer');
  const tagsBox = document.getElementById('mmgTags');
  const tags = Array.from(document.querySelectorAll('.mmg-search__tag'));

  if (!input || !btn || !tagsBox || !tags.length) return;

  function normalizar(texto) {
    return String(texto || '')
      .toLowerCase()
      .trim()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');
  }

  function ocultarTodo() {
    tagsBox.classList.add('d-none');
    tags.forEach(tag => tag.classList.add('d-none'));
  }

  function mostrarCoincidencias(valor) {
    const query = normalizar(valor);
    let visibles = 0;

    if (!query) {
      ocultarTodo();
      return [];
    }

    const coincidencias = [];

    tags.forEach(tag => {
      const etiqueta = normalizar(tag.dataset.etiqueta);

      if (etiqueta.includes(query)) {
        tag.classList.remove('d-none');
        coincidencias.push(tag);
        visibles++;
      } else {
        tag.classList.add('d-none');
      }
    });

    if (visibles > 0) {
      tagsBox.classList.remove('d-none');
    } else {
      tagsBox.classList.add('d-none');
    }

    return coincidencias;
  }

  function redirigirPrimeraCoincidencia() {
    const coincidencias = mostrarCoincidencias(input.value);
    if (!coincidencias.length) return;

    const url = coincidencias[0].dataset.url;
    if (url) {
      window.location.href = url;
    }
  }

  input.addEventListener('input', function () {
    mostrarCoincidencias(this.value);
  });

  input.addEventListener('focus', function () {
    mostrarCoincidencias(this.value);
  });

  input.addEventListener('keydown', function (e) {
    if (e.key === 'Enter') {
      e.preventDefault();
      redirigirPrimeraCoincidencia();
    }

    if (e.key === 'Escape') {
      ocultarTodo();
    }
  });

  btn.addEventListener('click', function () {
    redirigirPrimeraCoincidencia();
  });

  tags.forEach(tag => {
    tag.addEventListener('click', function () {
      const url = this.dataset.url;
      if (url) {
        window.location.href = url;
      }
    });
  });

  document.addEventListener('click', function (e) {
    const dentroBuscador = e.target.closest('.mmg-search__box');
    if (!dentroBuscador) {
      ocultarTodo();
    }
  });
});

// Contacto nuevo
document.addEventListener("DOMContentLoaded", function () {
  const botones = document.querySelectorAll(".js-btn-mostrar-hsform");

  if (!botones.length) return;

  botones.forEach((boton) => {
    boton.addEventListener("click", function () {
      const targetSelector = boton.getAttribute("data-target");
      if (!targetSelector) return;

      const contenedorHsForm = document.querySelector(targetSelector);
      if (!contenedorHsForm) return;

      if (contenedorHsForm.classList.contains("d-none")) {
        contenedorHsForm.classList.remove("d-none");
        contenedorHsForm.classList.add("is-visible");
      }

      setTimeout(() => {
        contenedorHsForm.scrollIntoView({
          behavior: "smooth",
          block: "start"
        });
      }, 120);
    });
  });
});

// Registro del evento (/encuentro-2026) — conectado, vía proxy
// same-origin, a la API de Google Apps Script (validarSocio,
// validarCodigo, registrarCompra). Sin pasarela de pago todavía:
// registrarCompra solo crea el folio y redirige a /pasarela-de-pago.
(() => {
  const form = document.getElementById("evento-registro-form");
  if (!form) return;

  // Proxy same-origin (Controllers/EventoApiController.php): el
  // navegador ya NO llama directamente a script.google.com — eso
  // disparaba el bloqueo de CORS (Apps Script no responde
  // Access-Control-Allow-Origin en el preflight). La URL real de
  // Apps Script queda centralizada solo en el proxy PHP.
  const EVENTO_API_URL = "/api/encuentro-2026";

  const checkSocio = form.querySelector("[data-registro-socio]");
  const campoIdSocio = form.querySelector("[data-registro-campo-socio]");
  const inputIdSocio = form.querySelector("[data-registro-id-socio]");
  const btnValidarSocio = form.querySelector("[data-registro-validar-socio]");
  const mensajeSocio = form.querySelector("[data-registro-socio-mensaje]");
  const campoAutorizacion = form.querySelector("[data-registro-campo-autorizacion]");
  const checkAutorizacion = form.querySelector("[data-registro-autorizacion]");
  const checkTerminos = form.querySelector("[data-registro-terminos]");
  const checkPrivacidad = form.querySelector("[data-registro-privacidad]");

  const btnAplicarCodigo = form.querySelector("[data-registro-aplicar-codigo]");
  const inputCodigo = form.querySelector("[data-registro-codigo]");
  const mensajeCodigo = form.querySelector("[data-registro-codigo-mensaje]");

  const lineaBeneficio = form.querySelector("[data-registro-linea-beneficio]");
  const beneficioLabel = form.querySelector("[data-registro-beneficio-label]");
  const beneficioValor = form.querySelector("[data-registro-beneficio-valor]");
  const notaSocio = form.querySelector("[data-registro-nota-socio]");
  const notaPendiente = form.querySelector("[data-registro-nota-pendiente]");
  const totalEl = form.querySelector("[data-registro-total]");

  const errorEl = form.querySelector("[data-registro-error]");
  const btnSubmit = form.querySelector("[data-registro-submit]");

  if (
    !checkSocio || !campoIdSocio || !inputIdSocio || !btnValidarSocio || !mensajeSocio ||
    !campoAutorizacion || !checkAutorizacion || !checkTerminos || !checkPrivacidad ||
    !btnAplicarCodigo || !inputCodigo || !mensajeCodigo ||
    !lineaBeneficio || !beneficioLabel || !beneficioValor ||
    !notaSocio || !notaPendiente || !totalEl || !errorEl || !btnSubmit
  ) {
    return;
  }

  const PRECIO_GENERAL = 4000;
  const PRECIO_SOCIO = 2000; // solo para mostrar el beneficio; el
                              // servidor determina el total real

  const formatoMXN = (valor) => "$" + Number(valor).toLocaleString("es-MX") + " MXN";

  // Estado de beneficios: socio y código NUNCA se combinan. Ambos
  // arrancan sin validar — nunca se asume nada por solo escribir texto.
  let socioValidado = false;
  let socioValidadoId = null;
  let codigoValidado = false;
  let codigoValidadoValor = null;
  let descuentoCodigo = 0;
  let totalCodigoActual = PRECIO_GENERAL;
  let enviando = false;

  function postAPI(payload) {
    return fetch(EVENTO_API_URL, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload)
    }).then((resp) => {
      if (!resp.ok) throw new Error("HTTP " + resp.status);
      return resp.json();
    });
  }

  function actualizarResumen() {
    lineaBeneficio.hidden = true;
    notaSocio.hidden = true;
    notaPendiente.hidden = true;

    if (socioValidado) {
      beneficioLabel.textContent = "Beneficio socio";
      beneficioValor.textContent = "-" + formatoMXN(PRECIO_GENERAL - PRECIO_SOCIO);
      lineaBeneficio.hidden = false;
      notaSocio.hidden = false;
      totalEl.textContent = formatoMXN(PRECIO_SOCIO);
    } else if (codigoValidado) {
      beneficioLabel.textContent = "Código promocional";
      beneficioValor.textContent = "-" + formatoMXN(descuentoCodigo);
      lineaBeneficio.hidden = false;
      totalEl.textContent = formatoMXN(totalCodigoActual);
    } else {
      totalEl.textContent = formatoMXN(PRECIO_GENERAL);
      if (checkSocio.checked) {
        notaPendiente.hidden = false;
      }
    }

    // SEGURIDAD:
    // El total mostrado en navegador es informativo.
    // El servidor debe validar nuevamente socio/cupón y determinar
    // el total definitivo antes de crear el pago.
  }

  // Muestra/oculta el campo de ID con una transición pequeña: primero
  // se quita [hidden] (o se pone) y, en el frame siguiente, se activa
  // .is-visible para que la transición de opacity/transform sí corra.
  function mostrarCampoSocio() {
    campoIdSocio.hidden = false;
    requestAnimationFrame(() => {
      campoIdSocio.classList.add("is-visible");
    });
  }

  function ocultarCampoSocio() {
    campoIdSocio.classList.remove("is-visible");
    campoIdSocio.hidden = true;
  }

  function limpiarMensajeSocio() {
    mensajeSocio.hidden = true;
    mensajeSocio.textContent = "";
    mensajeSocio.classList.remove("is-exito", "is-error");
  }

  function limpiarMensajeCodigo() {
    mensajeCodigo.hidden = true;
    mensajeCodigo.textContent = "";
    mensajeCodigo.classList.remove("is-exito", "is-error");
  }

  /**
   * Estado de carga reutilizable para VALIDAR SOCIO / APLICAR CÓDIGO.
   * Solo toca el <span data-btn-texto> interno (texto estático propio
   * del botón, nunca contenido recibido de la API) y el
   * <span class="evento-registro__btn-spinner"> ya presente en el
   * HTML — nunca reemplaza innerHTML.
   *
   * Fija el ancho actual del botón antes de cambiar el texto para que
   * VALIDANDO... no provoque saltos de layout frente a
   * VALIDAR SOCIO / APLICAR CÓDIGO.
   */
  function setButtonLoading(boton, cargando, textoCarga) {
    const textoEl = boton.querySelector("[data-btn-texto]");

    if (cargando) {
      if (!boton.dataset.textoOriginal && textoEl) {
        boton.dataset.textoOriginal = textoEl.textContent;
      }
      if (!boton.style.minWidth) {
        boton.style.minWidth = boton.getBoundingClientRect().width + "px";
      }

      boton.disabled = true;
      boton.setAttribute("aria-busy", "true");
      boton.classList.add("is-loading");
      if (textoEl) textoEl.textContent = textoCarga || "VALIDANDO...";
    } else {
      boton.disabled = false;
      boton.setAttribute("aria-busy", "false");
      boton.classList.remove("is-loading");
      boton.style.minWidth = "";
      if (textoEl && boton.dataset.textoOriginal) {
        textoEl.textContent = boton.dataset.textoOriginal;
      }
      delete boton.dataset.textoOriginal;
    }
  }

  function actualizarCamposSocio() {
    const activo = checkSocio.checked;

    if (activo) {
      mostrarCampoSocio();
    } else {
      ocultarCampoSocio();
    }

    campoAutorizacion.hidden = !activo;

    if (activo) {
      inputIdSocio.setAttribute("required", "required");
      checkAutorizacion.setAttribute("required", "required");
    } else {
      inputIdSocio.removeAttribute("required");
      checkAutorizacion.removeAttribute("required");
      inputIdSocio.value = "";
      checkAutorizacion.checked = false;

      socioValidado = false;
      socioValidadoId = null;
      limpiarMensajeSocio();
    }

    actualizarResumen();
    actualizarEstadoSubmit();
  }

  function actualizarEstadoSubmit() {
    if (enviando) {
      btnSubmit.disabled = true;
      return;
    }

    const camposBase = [
      form.querySelector("#evento-nombre"),
      form.querySelector("#evento-apellido"),
      form.querySelector("#evento-email"),
      form.querySelector("#evento-telefono")
    ];

    let valido = camposBase.every((campo) => campo && campo.value.trim().length > 0);
    valido = valido && checkTerminos.checked && checkPrivacidad.checked;

    if (checkSocio.checked) {
      valido = valido && inputIdSocio.value.trim().length > 0 && checkAutorizacion.checked;
    }

    btnSubmit.disabled = !valido;
  }

  checkSocio.addEventListener("change", actualizarCamposSocio);

  inputIdSocio.addEventListener("input", () => {
    // Un ID modificado invalida cualquier validación anterior: no debe
    // sobrevivir una validación vieja a un valor distinto.
    if (socioValidado && inputIdSocio.value.trim() !== socioValidadoId) {
      socioValidado = false;
      socioValidadoId = null;
      limpiarMensajeSocio();
    }

    actualizarResumen();
    actualizarEstadoSubmit();
  });

  btnValidarSocio.addEventListener("click", () => {
    const idSocio = inputIdSocio.value.trim();

    limpiarMensajeSocio();
    if (!idSocio) return;

    setButtonLoading(btnValidarSocio, true);

    postAPI({ accion: "validarSocio", id_socio: idSocio })
      .then((respuesta) => {
        if (respuesta && respuesta.valido === true) {
          socioValidado = true;
          socioValidadoId = idSocio;

          // El beneficio socio sustituye al código promocional: no se
          // combinan. Se limpia el estado visual del cupón aplicado.
          if (codigoValidado) {
            codigoValidado = false;
            codigoValidadoValor = null;
            limpiarMensajeCodigo();
          }

          mensajeSocio.textContent = "Socio validado.";
          mensajeSocio.classList.add("is-exito");
        } else {
          socioValidado = false;
          socioValidadoId = null;
          mensajeSocio.textContent =
            (respuesta && respuesta.mensaje) || "No pudimos validar este ID de socio.";
          mensajeSocio.classList.add("is-error");
        }

        mensajeSocio.hidden = false;
      })
      .catch(() => {
        socioValidado = false;
        socioValidadoId = null;
        mensajeSocio.textContent = "No pudimos validar tu ID en este momento. Inténtalo de nuevo.";
        mensajeSocio.classList.add("is-error");
        mensajeSocio.hidden = false;
      })
      .then(() => {
        actualizarResumen();
        actualizarEstadoSubmit();
      })
      .finally(() => {
        // Se restaura pase lo que pase: éxito, error de validación o
        // excepción — nunca deja el botón atascado en "VALIDANDO...".
        setButtonLoading(btnValidarSocio, false);
      });
  });

  inputCodigo.addEventListener("input", () => {
    if (codigoValidado && inputCodigo.value.trim() !== codigoValidadoValor) {
      codigoValidado = false;
      codigoValidadoValor = null;
      limpiarMensajeCodigo();
      actualizarResumen();
      actualizarEstadoSubmit();
    }
  });

  btnAplicarCodigo.addEventListener("click", () => {
    const codigo = inputCodigo.value.trim();

    limpiarMensajeCodigo();
    if (!codigo) return;

    // No acumulable con el beneficio de socio ya validado.
    if (socioValidado) {
      mensajeCodigo.textContent = "El precio de socio no es acumulable con códigos promocionales.";
      mensajeCodigo.classList.add("is-error");
      mensajeCodigo.hidden = false;
      return;
    }

    setButtonLoading(btnAplicarCodigo, true);

    postAPI({ accion: "validarCodigo", codigo_promocional: codigo })
      .then((respuesta) => {
        if (respuesta && respuesta.valido === true) {
          codigoValidado = true;
          codigoValidadoValor = codigo;
          descuentoCodigo = Number(respuesta.descuento) || 0;
          totalCodigoActual = Number(respuesta.total);
          if (isNaN(totalCodigoActual)) {
            totalCodigoActual = PRECIO_GENERAL - descuentoCodigo;
          }

          mensajeCodigo.textContent = respuesta.mensaje || "Código aplicado.";
          mensajeCodigo.classList.add("is-exito");
        } else {
          codigoValidado = false;
          codigoValidadoValor = null;
          mensajeCodigo.textContent =
            (respuesta && respuesta.mensaje) || "Este código no es válido.";
          mensajeCodigo.classList.add("is-error");
        }

        mensajeCodigo.hidden = false;
      })
      .catch(() => {
        codigoValidado = false;
        codigoValidadoValor = null;
        mensajeCodigo.textContent = "No pudimos validar el código en este momento. Inténtalo de nuevo.";
        mensajeCodigo.classList.add("is-error");
        mensajeCodigo.hidden = false;
      })
      .then(() => {
        actualizarResumen();
        actualizarEstadoSubmit();
      })
      .finally(() => {
        // Se restaura pase lo que pase: éxito, error de validación o
        // excepción — nunca deja el botón atascado en "VALIDANDO...".
        setButtonLoading(btnAplicarCodigo, false);
      });
  });

  form.addEventListener("input", actualizarEstadoSubmit);
  form.addEventListener("change", actualizarEstadoSubmit);

  form.addEventListener("submit", (e) => {
    e.preventDefault();

    if (enviando || btnSubmit.disabled) return;

    errorEl.hidden = true;
    errorEl.textContent = "";

    enviando = true;
    // Mismo helper reutilizado por VALIDAR SOCIO / APLICAR CÓDIGO: solo
    // toca el <span data-btn-texto> y el spinner ya presentes en el
    // HTML, nunca reemplaza el innerHTML del botón (evitaría perder
    // esos spans, a diferencia de asignar btnSubmit.textContent).
    setButtonLoading(btnSubmit, true, "PROCESANDO...");

    // SEGURIDAD:
    // El total mostrado en navegador es únicamente informativo. Este
    // payload NO envía precio_general/descuento/total calculados en
    // el navegador como si fueran una autoridad — el servidor debe
    // validar de nuevo socio/cupón y determinar el total definitivo
    // antes de crear cualquier orden de pago.
    const payload = {
      accion: "registrarCompra",

      nombre: form.querySelector("#evento-nombre").value.trim(),
      apellido: form.querySelector("#evento-apellido").value.trim(),
      correo: form.querySelector("#evento-email").value.trim(),
      telefono: form.querySelector("#evento-telefono").value.trim(),

      especialidad_profesion: form.querySelector("#evento-especialidad").value.trim(),
      institucion_empresa: form.querySelector("#evento-institucion").value.trim(),
      ciudad: form.querySelector("#evento-ciudad").value.trim(),
      como_conocio_evento: form.querySelector("#evento-como-te-enteraste").value.trim(),

      es_socio: checkSocio.checked,
      id_socio: inputIdSocio.value.trim(),

      codigo_promocional: inputCodigo.value.trim(),

      metodo_pago: "PENDIENTE",

      acepta_terminos: checkTerminos.checked,
      acepta_privacidad: checkPrivacidad.checked,
      acepta_validacion_socio: checkAutorizacion.checked,

      observaciones: ""
    };

    postAPI(payload)
      .then((respuesta) => {
        const folio =
          respuesta && respuesta.ok === true && respuesta.compra
            ? respuesta.compra.folio
            : null;

        if (!folio) {
          throw new Error("Respuesta de registrarCompra sin folio válido");
        }

        try {
          sessionStorage.setItem("eventoMercerFolio", folio);
          sessionStorage.setItem("eventoMercerCompra", JSON.stringify({
            folio: folio,
            total: respuesta.compra.total,
            estado_pago: respuesta.compra.estado_pago
          }));
        } catch (errStorage) {
          // sessionStorage puede fallar (modo privado, cuota, etc.); no
          // bloquea la redirección — la pasarela avisa si no encuentra folio.
        }

        // Éxito: el botón se mantiene en PROCESANDO... (loading +
        // disabled + aria-busy) mientras redirige, no se reactiva —
        // así no hay instante en el que se pueda volver a pulsar.
        window.location.href = "/pasarela-de-pago";
      })
      .catch(() => {
        enviando = false;
        setButtonLoading(btnSubmit, false);

        errorEl.textContent = "No pudimos completar tu registro en este momento. Inténtalo nuevamente.";
        errorEl.hidden = false;

        // No se hace btnSubmit.disabled = false a secas: se recalcula
        // con la validación real del formulario (podría seguir inválido).
        actualizarEstadoSubmit();
      });
  });

  // Estado inicial: socio desactivado, precio general, CTA deshabilitado
  // hasta cumplir los campos obligatorios.
  actualizarCamposSocio();
})();

// Modal de Términos y Condiciones del evento
(() => {
  const botonesAbrir = document.querySelectorAll("[data-abrir-modal]");
  if (!botonesAbrir.length) return;

  let modalActivo = null;
  let disparadorActivo = null;

  function abrirModal(modal, disparador) {
    modalActivo = modal;
    disparadorActivo = disparador;

    modal.hidden = false;
    modal.setAttribute("aria-hidden", "false");
    document.body.classList.add("evento-modal-open");

    const cerrarBtn = modal.querySelector(".evento-modal__cerrar");
    if (cerrarBtn) cerrarBtn.focus();
  }

  function cerrarModal() {
    if (!modalActivo) return;

    modalActivo.hidden = true;
    modalActivo.setAttribute("aria-hidden", "true");
    document.body.classList.remove("evento-modal-open");

    if (disparadorActivo) disparadorActivo.focus();

    modalActivo = null;
    disparadorActivo = null;
  }

  botonesAbrir.forEach((boton) => {
    boton.addEventListener("click", () => {
      const modal = document.getElementById(boton.getAttribute("data-abrir-modal"));
      if (modal) abrirModal(modal, boton);
    });
  });

  document.querySelectorAll("[data-modal-cerrar]").forEach((el) => {
    el.addEventListener("click", cerrarModal);
  });

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && modalActivo) cerrarModal();
  });
})();

// Popup promocional global del Encuentro 2026. Se imprime en el DOM
// desde Pagina::render() en todas las páginas públicas excepto
// /encuentro-2026 (esa exclusión vive en PHP, no aquí) — este script
// solo se activa si encuentra el markup. Deliberadamente SIN
// localStorage/sessionStorage/cookies ni supresión temporal: debe
// reaparecer en cada carga y en cada navegación, tal como se pidió.
(() => {
  const popup = document.querySelector("[data-popup-encuentro]");
  if (!popup) return;

  const overlay = popup.querySelector("[data-popup-encuentro-overlay]");
  const cerrarBtn = popup.querySelector("[data-popup-encuentro-cerrar]");

  if (!overlay || !cerrarBtn) return;

  const RETRASO_MS = 1000;

  function abrirPopup() {
    popup.hidden = false;
    document.body.classList.add("popup-encuentro-open");
    cerrarBtn.focus();
  }

  function cerrarPopup() {
    popup.hidden = true;
    document.body.classList.remove("popup-encuentro-open");
  }

  cerrarBtn.addEventListener("click", cerrarPopup);
  overlay.addEventListener("click", cerrarPopup);

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && !popup.hidden) {
      cerrarPopup();
    }
  });

  setTimeout(abrirPopup, RETRASO_MS);
})();